var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M14.293 2.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-12 12A1 1 0 0 1 9 22H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 .293-.707z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }